import { render } from "./ServiciosES.vue?vue&type=template&id=bb1481da&scoped=true"
import script from "./ServiciosES.vue?vue&type=script&lang=js"
export * from "./ServiciosES.vue?vue&type=script&lang=js"

import "./ServiciosES.vue?vue&type=style&index=0&id=bb1481da&scoped=true&lang=css"
import "./ServiciosES.vue?vue&type=style&index=1&id=bb1481da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1481da"]])

export default __exports__